export default {
      id: "xtype_xcargo-usage",
      viewBox: "0 0 28 14",
      url: __webpack_public_path__ + "img/icons.svg#xtype_xcargo",
      toString: function () {
        return this.url;
      }
    }